/**
 * WMPCM-10948 AC-4 — the Filters badge count: number of selected keyword badges, plus 1 if
 * "Placed" is set to Yes/No (not "Any"), plus 1 if a filename search term is entered.
 *
 * `placedIsRestricted` is the caller's job to compute from whatever Placed control exists —
 * the tri-state Any/Yes/No control (Figma node 277:23022) computes it as
 * `placedFilter !== 'any'`; see `filterClikArtByPlaced` (`clikart-placed-filter.ts`) for the
 * matching filter predicate.
 */
export function computeClikArtActiveFilterCount(params: {
  selectedKeywordCount: number
  placedIsRestricted: boolean
  filenameSearchQuery: string
}): number {
  const { selectedKeywordCount, placedIsRestricted, filenameSearchQuery } = params

  return (
    selectedKeywordCount +
    (placedIsRestricted ? 1 : 0) +
    (filenameSearchQuery.trim() !== '' ? 1 : 0)
  )
}
